export default __webpack_public_path__ + "static/media/benefit_3@3x.336e12e6.png";